import { GzRmTopFindingsImpactWidgetWebComponent } from './component/GzRmTopFindingsImpactWidgetWebComponent';

export { GzRmTopFindingsImpactWidgetWebComponent };
